import React from 'react';
import { StyledDivider } from './style';

export interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  maxWidth?: number | string;
  maxHeight?: number | string;
  thickness?: number;
}

export const Divider = ({
    orientation = 'horizontal',
    marginTop = 20,
    marginBottom = 20,
    marginLeft,
    marginRight,
    maxWidth,
    maxHeight,
    thickness = 1,
  }: DividerProps) => {
  return (
    <StyledDivider
      $orientation={orientation}
      $marginTop={marginTop}
      $marginBottom={marginBottom}
      $marginLeft={marginLeft}
      $marginRight={marginRight}
      $maxWidth={maxWidth}
      $maxHeight={maxHeight}
      $thickness={thickness}
      aria-hidden
    />
  );
};
